//      
                                                                               

              
                           
                        
                              
                                          
   

export default ({
  isMovingForward,
  isInHomeList,
  insideDestination,
  location,
}      )          => {
  // cannot move in the list
  if (!insideDestination.length) {
    return null;
  }

  const currentIndex         = location.index;
  const proposedIndex         = isMovingForward
    ? currentIndex + 1
    : currentIndex - 1;

  // Accounting for lists that might not start with an index of 0
  const firstIndex         = insideDestination[0].descriptor.index;
  const lastIndex         =
    insideDestination[insideDestination.length - 1].descriptor.index;

  // When in foreign list we allow movement after the last item
  const upperBound         = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }
  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/move-in-direction/move-to-next-place/move-to-next-index/from-reorder.js